
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"9","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"1605.5","cy":"282.5","r":"3.5","transform":"translate(-1601 -278)","fill-rule":"nonzero","stroke":"#515358","stroke-width":"1.25","fill":"none"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/cluster_svgs/point.svg